(() => {
  const init = (root = document) => {
    root.querySelectorAll('.cv-product--desire .cv-pdp-gallery').forEach(gallery => {
      if (gallery.dataset.museReady) return;
      gallery.dataset.museReady = 'true';
      const dialog = gallery.querySelector('dialog');
      const opener = gallery.querySelector('[data-pdp-zoom]');
      opener?.addEventListener('click', () => {
        const active = gallery.querySelector('[data-cv-image][aria-pressed="true"]');
        const current = gallery.querySelector('[data-cv-featured] img');
        if (!current || !dialog) return;
        const large = new Image();
        large.src = active?.dataset.cvFullImage || current.currentSrc || current.src;
        large.alt = current.alt;
        large.width = 1800;
        large.height = 2400;
        gallery.querySelector('[data-pdp-large-image]').replaceChildren(large);
        dialog.showModal();
        gallery.querySelector('[data-pdp-close]').focus();
      });
      gallery.querySelector('[data-pdp-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog?.addEventListener('close', () => opener?.focus());
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
